<template>
  <van-popup v-model="popShow" position="bottom" @click-overlay="onClickOverlay">
    <div class="language_popup">
      <div class="inner_box">
        <div
          class="language_item"
          :class="item.languageNo === curLanguage && 'selected'"
          v-for="item in languageList"
          :key="item.languageNo"
          @click="selectLanguage(item.languageNo)"
        >
          {{ item.languageName + '(' + item.languageNameLocal + ')' }}
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { loadLanguage } from '../configs/language'

export default {
  name: 'LanguagePopup',
  props: {
    show: Boolean
  },
  data() {
    return {
      popShow: false,
      curLanguage: 'en',
      languageList: [
        { languageNo: 'en', languageNameLocal: 'English', languageName: 'English' },
        { languageNo: 'hi', languageNameLocal: 'हिन्दी', languageName: 'Hindi' },
        { languageNo: 'ur', languageNameLocal: 'اردو', languageName: 'Urdu' },
        { languageNo: 'ar', languageNameLocal: 'اللغة العربية', languageName: 'Arabic' },
        { languageNo: 'es', languageNameLocal: 'español', languageName: 'Spanish' },
        { languageNo: 'pt', languageNameLocal: 'Português', languageName: 'Portuguese' },
        { languageNo: 'bn', languageNameLocal: 'বাংলা', languageName: 'Bengali' },
        { languageNo: 'fr', languageNameLocal: 'Français', languageName: 'French' },
        { languageNo: 'ru', languageNameLocal: 'Русский', languageName: 'Russian' },
        { languageNo: 'id', languageNameLocal: 'bahasa Indonesia', languageName: 'Indonesian' },
        { languageNo: 'vi', languageNameLocal: 'Tiếng Việt', languageName: 'Vietnamese' },
        { languageNo: 'th', languageNameLocal: 'ภาษาไทย', languageName: 'Thai' },
        { languageNo: 'zh-TW', languageNameLocal: '繁體中文', languageName: 'Chinese Traditional' },
        { languageNo: 'zh-CN', languageNameLocal: '简体中文', languageName: 'Chinese Simplified' },
        { languageNo: 'tr', languageNameLocal: 'Türkçe', languageName: 'Turkish' }
      ]
    }
  },
  created() {
    this.curLanguage = localStorage.getItem('language')
  },
  watch: {
    show: {
      handler(newValue) {
        this.popShow = newValue
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    onClickOverlay() {
      this.$emit('closePopup')
    },
    selectLanguage(lang) {
      loadLanguage(lang)
      const isMirror = localStorage.getItem('isMirror')
      this.$store.commit('setIsMirroring', !!(isMirror && isMirror === '1'))
      this.curLanguage = lang
      this.$emit('closePopup')
      this.$emit('changeLanguage', lang)
    }
  }
}
</script>

<style scoped>
.language_popup {
  display: flex;
  width: 100%;
  height: 80vh;
  flex-direction: column;
  align-items: center;
  color: #2f2f2f;
  font-family: 'PingFang SC';
  font-size: 0.16rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.24rem;
  padding: 0.12rem 0;
  overflow: hidden;
  border-radius: 0.24rem 0.24rem 0px 0px;
  background: #fff;
  box-sizing: border-box;
}

.inner_box {
  height: 100%;
  width: 100%;
  overflow-y: auto;
  scrollbar-width: none;
}

.inner_box::-webkit-scrollbar {
  width: 0;
}

.language_item {
  display: flex;
  height: 0.6rem;
  width: 100%;
  justify-content: center;
  align-items: center;
  border-bottom: 0.5px solid #ececec;
  flex-shrink: 0;
}

.selected {
  background: linear-gradient(
    270deg,
    rgba(0, 255, 101, 0) 0%,
    rgba(7, 228, 94, 0.3) 40%,
    rgba(0, 255, 101, 0.3) 60%,
    rgba(0, 255, 101, 0) 100%
  );
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/LanguagePopup.vue